var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.session.testmode)?_c('span',{staticClass:"inline-flex items-center rounded-full bg-markencode-blue px-2 py-1 text-xs font-medium text-white"},[_vm._v("Test")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }